import { FC } from "react";
import { TranslationScopes } from "@finbackoffice/enums";
import { useRuntimeConfig } from "@finbackoffice/site-core";
import Translate from "components/base/translate/Translate";
import styles from "../policies.module.sass";
import PoliciesCommonContent from "../PoliciesCommonContent";

const PoliciesTerms: FC = () => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");

    return (
        <PoliciesCommonContent
            translationKey="terms"
            translationScope={TranslationScopes.PoliciesTerms}
            headingIcon={{ width: 17, height: 20 }}
            wrapperClassName={styles.termsContent}>
            <Translate
                tid="policies_terms_content_1"
                namespace={TranslationScopes.PoliciesTerms}
                replace={{ app_name: COMMON_SITE_CONFIGS.appName }}
                dangerous>
                <div />
            </Translate>
            <Translate
                tid="policies_terms_content_2"
                namespace={TranslationScopes.PoliciesTerms}
                replace={{ app_name: COMMON_SITE_CONFIGS.appName }}
                dangerous>
                <div />
            </Translate>
            <Translate
                tid="policies_terms_content_3"
                namespace={TranslationScopes.PoliciesTerms}
                replace={{ app_name: COMMON_SITE_CONFIGS.appName }}
                dangerous>
                <div />
            </Translate>
            <Translate
                tid="policies_terms_content_4"
                namespace={TranslationScopes.PoliciesTerms}
                replace={{ app_name: COMMON_SITE_CONFIGS.appName }}
                dangerous>
                <div />
            </Translate>
        </PoliciesCommonContent>
    );
};

export default PoliciesTerms;
